import { PagePatterns } from "@features/shared/page-type/page-types";
import { isUpsellLibraryPath } from "./access";

// On login/app load paused users land on the profile root, not straight in
// the subscriptions settings: landing deep in settings breaks the back button
// (it acts as browser back and immediately re-triggers the gate redirect).
export const PAUSED_SUBSCRIPTION_REDIRECT_PATH = PagePatterns.PROFILE;

export const PAUSED_SUBSCRIPTION_IN_APP_REDIRECT_PATH = PagePatterns.PROFILE_SETTINGS_SUBSCRIPTIONS;

export const isPausedSubscriptionStatus = (status?: string | null): boolean => status === "paused";

export const isPausedSubscriptionAllowedPath = (pathname: string): boolean => {
    if (pathname.startsWith("/profile/settings/subscriptions/renew")) {
        return false;
    }

    if (pathname.startsWith("/profile")) {
        return true;
    }

    // Upsell packs are one-time purchases: a paused student keeps them, the
    // same way an expired one does (see features/subscription/access.ts).
    if (isUpsellLibraryPath(pathname)) {
        return true;
    }

    return (
        pathname.startsWith("/terms") ||
        pathname.startsWith("/privacy") ||
        pathname.startsWith("/subscription-terms")
    );
};
